<template>
    <div class="">
        <div class="mb-3">
            <h2 class="text-yellow-200">Oops. Wrong guess</h2>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WonLevel'
}
</script>
